import React, { Component } from 'react';

class ProductList extends Component {
  render() {
    return (
        <ul className="product-list">
          {this.props.children}
        </ul>
    );
  }
}
export default ProductList;
